import { render, staticRenderFns } from "./AudioTool.vue?vue&type=template&id=0d5ef4a4&scoped=true&"
import script from "./AudioTool.vue?vue&type=script&lang=js&"
export * from "./AudioTool.vue?vue&type=script&lang=js&"
import style0 from "./AudioTool.vue?vue&type=style&index=0&id=0d5ef4a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5ef4a4",
  null
  
)

export default component.exports